import lang from '@/utils/getUALang';
import LIST from '../../public/assets/config/list';
import HOT from '../../public/assets/config/hot';
import ALL from '../../public/assets/config/all';

// 获取热门列表
export const getHotList = () => HOT[lang];

// 获取全部列表（用于搜索）
export const getAllList = () => ALL[lang];

// 根据 filename 获取对应的 content
export const getDetails = (id: string) => {
  try {
    const list = LIST[lang];
    if (list.length > 0) {
      return list.find((value) => value.fileName === id);
    } else {
      return {};
    }
  } catch {
    return {};
  }
};
